import { render, staticRenderFns } from "./BrandPrivacy.vue?vue&type=template&id=1ecb5f10&scoped=true"
import script from "./BrandPrivacy.vue?vue&type=script&lang=js"
export * from "./BrandPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb5f10",
  null
  
)

export default component.exports